// removed by extract-text-webpack-plugin
module.exports = {"thumb":"thumb-LO3TK","routeContainer":"routeContainer-3Rtuw","details":"details-1nLSn","name":"name-yVeX2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/shared/_routeThumb.css
// module id = 1219
// module chunks = 1